import { useState } from "react";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";

import "../Assets/css/Style.css";

function AnnualReport() {
  const [open, setOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const handleOpen = (url) => {
    setPdfUrl(url);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPdfUrl("");
  };

  const getPdfSrc = (url) => {
    if (!url) return "";
    return url.includes("#")
      ? `${url}&toolbar=0&navpanes=0&scrollbar=0`
      : `${url}#toolbar=0&navpanes=0&scrollbar=0`;
  };

  // 📌 Annual Report Data
  const annual_report_data = [
    {
      session_year: "2015-2016",
      title: "Annual Report 2015-2016",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2015-2016.pdf",
    },
    {
      session_year: "2016-2017",
      title: "Annual Report 2016-2017",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2016-2017.pdf",
    },
    {
      session_year: "2017-2018",
      title: "Annual Report 2017-2018",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2017-2018.pdf",
    },
    {
      session_year: "2018-2019",
      title: "Annual Report 2018-2019",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2018-2019.pdf",
    },
    {
      session_year: "2019-2020",
      title: "Annual Report 2019-2020",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2019-2020.pdf",
    },
    {
      session_year: "2020-2021",
      title: "Annual Report 2020-2021",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2020-2021.pdf",
    },
    {
      session_year: "2021-2022",
      title: "Annual Report 2021-2022",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2021-2022.pdf",
    },
    {
      session_year: "2022-2023",
      title: "Annual Report 2022-2023",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2022-2023.pdf",
    },
    {
      session_year: "2023-2024",
      title: "Annual Report 2023-2024",
      pdf: "https://webapi.entab.info/api/image/NCSR/public/pdf/ANNUAL REPORT 2023-2024.pdf",
    },
  ];

  return (
    <>
      <Header />
      <Breadcrumb title="Annual Report" tabName="Annual Report" />

      <div className="innerPage annual_report">
        <div className="container">
          <div className="row">
            {annual_report_data
              .sort((a, b) => {
                return (
                  parseInt(b.session_year.split("-")[0], 10) -
                  parseInt(a.session_year.split("-")[0], 10)
                );
              })
              .map((item, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                  <p className="magazine_blk_p">{item.session_year}</p>

                  <div className="magazine_blk new_magazine">
                    <div
                      role="button"
                      tabIndex={0}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpen(item.pdf)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          handleOpen(item.pdf);
                        }
                      }}
                    >
                      <h4>{item.title}</h4>

                      <button
                        type="button"
                        className="mt-4"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleOpen(item.pdf);
                        }}
                      >
                        View
                      </button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* 📄 PDF MODAL */}
        {open && (
          <div
            className="annual_report_pdf-modal-backdrop"
            role="dialog"
            aria-modal="true"
            onClick={handleClose}
          >
            <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                className="annual_report_close-btn"
                onClick={handleClose}
              >
                ✕
              </button>

              <iframe
                src={getPdfSrc(pdfUrl)}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="PDF Viewer"
              />
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}

export default AnnualReport;
